export enum TypeDate {
  CreatedAtDateTime = 1,
  CourierDeliveryDateTime = 2,
  AllCreatedNotFinished = 3
}
